import { Control, Controller } from "react-hook-form";

import { useFeatureflags } from "@web-app/api";
import { SCANNABLE_CODE_FEATURE } from "@web-app/utils/scannableCode";

import { ScannableCodeEntriesEditor } from "../../ScannableCodeEntries/ScannableCodeEntriesEditor";
import { validateScannableCodeEntries } from "../../ScannableCodeEntries/scannableCodeEntries";
import { FormValues } from "../types";

/** Barcode rows for the codes to scan at one stop, behind the scannableCode flag. */
export function ScannableCodeDetailsField({
  control,
  name,
}: {
  control: Control<FormValues>;
  name: "dropoffCodes" | "pickupCodes";
}) {
  const { hasFeature } = useFeatureflags();
  if (!hasFeature(SCANNABLE_CODE_FEATURE)) return null;

  return (
    <Controller
      name={name}
      control={control}
      rules={{ validate: validateScannableCodeEntries }}
      render={({ field, fieldState: { error } }) => (
        <ScannableCodeEntriesEditor
          entries={field.value ?? []}
          error={error?.message}
          onChange={field.onChange}
        />
      )}
    />
  );
}
